/**
 * @file   src\components\Common\Loader.js
 * @brief  This file is responsible for loader component
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
const Loader = (props) => {
  const { loaderText } = props;
  return (
    <div className="overlay-photo-upload">
      <div className="overlay-inner-photo-upload">
        <div className="overlay-content-photo-upload">
          <span className="spinner-photo-upload"></span>
          <span className="spinner-text">{loaderText}</span>
        </div>
      </div>
    </div>
  );
};
export default Loader;
